var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoveFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5715 2.20153C19.4873 1.11737 18.0168 0.508301 16.4835 0.508301C14.9502 0.508301 13.4798 1.11737 12.3955 2.20153L11.2819 3.31509L10.1683 2.20153C9.633 1.65788 8.99535 1.22554 8.29214 0.929494C7.58894 0.63345 6.83409 0.479542 6.07112 0.476605C5.30815 0.473669 4.55214 0.621792 3.84668 0.912414C3.14122 1.20304 2.50026 1.63041 1.96075 2.16992C1.42124 2.70943 0.993858 3.35041 0.703236 4.05587C0.412613 4.76133 0.264501 5.51728 0.267438 6.28026C0.270375 7.04323 0.424302 7.79809 0.720346 8.5013C1.01639 9.2045 1.4487 9.84214 1.99234 10.3775L3.10594 11.4925L11.2819 19.6686L19.4594 11.4925L20.573 10.3775C21.1101 9.84081 21.5363 9.20353 21.827 8.50209C22.1177 7.80065 22.2674 7.04881 22.2674 6.2895C22.2674 5.53019 22.1177 4.77836 21.827 4.07691C21.5363 3.37547 21.1087 2.73819 20.5715 2.20153Z",
    fill: "#FC3D3D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveFill);
export default __webpack_public_path__ + "static/media/love_fill.f4f5abc3422ca7c1d450becb66d7b8c9.svg";
export { ForwardRef as ReactComponent };